<ng-container *letVar="actionList$ | async as actionList">
    <ng-container *ngIf="isTopBarDisplay; else dropdownDisplay">
        <div *ngIf="actionList?.length" class="action-toolbar-container">
            <div class="action-toolbar-item">
                <mat-icon class="menu-icon fp-icon-minus-squared unselect" (click)="onClearSelection($event)"></mat-icon>
            </div>
            <ng-container *ngFor="let action of actionList">
                <div class="action-toolbar-item" (click)="selectAction(action)">
                    <mat-icon class="menu-icon" [ngClass]="[action.icon]"></mat-icon>
                    <span>{{ action.title }}</span>
                </div>
            </ng-container>
        </div>
    </ng-container>
    <ng-template #dropdownDisplay>
        <mat-form-field class="action-selector">
            <select matNativeControl [(ngModel)]="actionModel" (ngModelChange)="selectAction($event)">
                <option [ngValue]="undefined" i18n="@@SHARED.LIST.SELECT_ACTION">
                    Select {!selectedRow, select, true{a Row} other{an Action}}
                </option>
                <ng-container *ngFor="let action of actionList">
                    <option [ngValue]="action">{{ action.title }}</option>
                </ng-container>
            </select>
        </mat-form-field>
    </ng-template>
</ng-container>
